import React from 'react';
import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { TrendingDown, TrendingUp, Minus } from 'lucide-react';
import { C, num } from './theme';
import { Empty, Panel } from './KpiGrid';

const BAR = [C.purple, C.green, C.orange, C.magenta, C.amber, C.leaf];

const Delta = ({ row }) => {
  if (row.delta == null) return <span className="text-[11.5px]" style={{ color: C.muted }}>Primeiro ano da série</span>;
  const Icon = row.delta > 0 ? TrendingUp : row.delta < 0 ? TrendingDown : Minus;
  const color = row.delta > 0 ? C.green : row.delta < 0 ? C.orange : C.muted;
  return (
    <span className="inline-flex items-center gap-1 text-[12px] font-bold" style={{ color }} data-testid={`year-delta-${row.year}`}>
      <Icon className="h-3.5 w-3.5" />{row.delta > 0 ? '+' : ''}{num(row.delta)}
      {row.delta_pct != null && ` (${row.delta_pct > 0 ? '+' : ''}${row.delta_pct.toLocaleString('pt-BR')}%)`} vs. ano anterior
    </span>
  );
};

export function YearBlock({ rows, year }) {
  return (
    <Panel kicker="Bloco obrigatório" title="Alunos ativos por ano letivo" testid="block-students-by-year">
      {!rows.length ? <Empty testid="year-empty">Nenhum vínculo anual ativo encontrado.</Empty> : (
        <div className="grid gap-5 lg:grid-cols-[1fr_1.2fr]">
          <div className="grid grid-cols-2 gap-3 content-start">
            {rows.map((r, i) => (
              <div key={r.year} className="rounded-2xl p-4 dash-rise" data-testid={`year-card-${r.year}`}
                style={{ background: r.year === year ? C.ink : C.paper, color: r.year === year ? '#fff' : C.ink, animationDelay: `${i * 60}ms` }}>
                <p className="text-[12px] font-bold uppercase tracking-[0.2em] opacity-70">{r.year}</p>
                <p className="mt-1 text-3xl font-extrabold tabular-nums" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid={`year-count-${r.year}`}>{num(r.students)}</p>
                <p className="text-[12px] opacity-70 mb-1">alunos ativos</p>
                <div className={r.year === year ? '[&_*]:!text-white/90' : ''}><Delta row={r} /></div>
              </div>
            ))}
          </div>
          <div className="h-[240px]" data-testid="year-chart">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={rows} margin={{ top: 22, right: 8, left: -18, bottom: 0 }}>
                <CartesianGrid vertical={false} stroke={C.line} />
                <XAxis dataKey="year" tickLine={false} axisLine={false} tick={{ fill: C.muted, fontSize: 12, fontWeight: 700 }} />
                <YAxis allowDecimals={false} tickLine={false} axisLine={false} tick={{ fill: C.muted, fontSize: 11 }} />
                <Tooltip cursor={{ fill: `${C.purple}0d` }} formatter={(v) => [`${num(v)} alunos`, 'Ativos']} labelFormatter={(l) => `Ano letivo ${l}`} />
                <Bar dataKey="students" radius={[12, 12, 4, 4]} maxBarSize={72}>
                  {rows.map((r, i) => <Cell key={r.year} fill={BAR[i % BAR.length]} />)}
                  <LabelList dataKey="students" position="top" formatter={num} style={{ fill: C.ink, fontWeight: 800, fontSize: 12 }} />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </Panel>
  );
}
